"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildKey = void 0;
function buildKey(impression) {
    return impression.keyName + ":" + impression.feature + ":" + impression.treatment + ":" + impression.label + ":" + impression.changeNumber;
}
exports.buildKey = buildKey;
